import React from 'react'
import Table from "../../Table";

export default function DealsListView({ columns, data, pageCount, fetchData, loading }) {


  return (
    <div>
      <Table
        columns={columns}
        data={data}
        pageCount={pageCount}
        fetchData={fetchData}
        loading={loading}
      ></Table>
    </div>
  )
}
